/* hs-eslint ignored failing-rules */
/* eslint-disable react/no-unused-prop-types */

import { useContext } from 'react';
import I18n from 'I18n';
import TimezoneTypes from '../constants/TimezoneTypes';
// @ts-expect-error untyped JS module
import formatDuration from '../utils/formatRelativeDuration';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error untyped
const getRelativeDuration = (from, to, options) => formatDuration(I18n.moment.duration(Math.abs(to.diff(from))), options);
function FormattedDuration({
  includeAffix = false,
  type = TimezoneTypes.PORTAL,
  from,
  to,
  format,
  combined = false
}) {
  useContext(I18nHMRContext);
  const nowMoment = I18n.moment[type]();
  let duration;
  if (!to && !from) {
    duration = '';
  } else if (!to) {
    // @ts-expect-error from/to types are wider than MomentInput
    const fromValue = I18n.moment[type](from);
    duration = format ? getRelativeDuration(fromValue, nowMoment, {
      format,
      combined
    }) : fromValue.toNow(!includeAffix);
  } else if (!from) {
    const toValue = I18n.moment[type](to);
    duration = format ? getRelativeDuration(nowMoment, toValue, {
      format,
      combined
    }) : toValue.fromNow(!includeAffix);
  } else {
    const fromValue = I18n.moment[type](from);
    const toValue = I18n.moment[type](to);
    duration = format ? getRelativeDuration(fromValue, toValue, {
      format,
      combined
    }) : toValue.from(fromValue, !includeAffix);
  }
  return /*#__PURE__*/_jsx("span", {
    children: duration
  });
}
FormattedDuration.displayName = 'FormattedDuration';
export default FormattedDuration;